module.exports = __webpack_public_path__ + "img/benin.b879003.webp";